import script from "./PdRecipientOption.vue?vue&type=script&setup=true&lang=js"
export * from "./PdRecipientOption.vue?vue&type=script&setup=true&lang=js"

import "./PdRecipientOption.vue?vue&type=style&index=0&id=480a66ce&scoped=true&lang=css"

import exportComponent from "../../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-480a66ce"]])

export default __exports__